module.exports = __webpack_public_path__ + "img/ic-support.ece8f044.svg";